import React from "react";

import {
  CLOSED_BUMPER_TYPE_OPTIONS,
  CLOSED_SPARE_WHEEL_OPTIONS,
} from "../../../data";
import { CardRow, StructureSection } from "../OpenBoxQuotes/BoxStructureFields";
import {
  AccessoryNoteCard,
  AccessoryQuantityCard,
  AccessoryTypeCard,
} from "./AccessoriesCards";
import AccessoriesTable from "./AccessoriesTable";
import { closedKey } from "./BoxStructureCards";

const AccessoriesSafety = () => (
  <>
    <StructureSection titleKey={closedKey("SECTIONS.SAFETY")}>
      <CardRow columns={3}>
        <AccessoryTypeCard
          cardKey="rearBumper"
          titleKey={closedKey("CARDS.REAR_BUMPER")}
          options={CLOSED_BUMPER_TYPE_OPTIONS}
        />
        <AccessoryTypeCard
          cardKey="spareWheelCarrier"
          titleKey={closedKey("CARDS.SPARE_WHEEL_CARRIER")}
          options={CLOSED_SPARE_WHEEL_OPTIONS}
        />
        <AccessoryQuantityCard
          cardKey="extinguisherMount"
          titleKey={closedKey("CARDS.EXTINGUISHER_MOUNT")}
        />
      </CardRow>
      <CardRow columns={3}>
        <AccessoryNoteCard
          cardKey="hazmatSigns"
          titleKey={closedKey("CARDS.HAZMAT_SIGNS")}
        />
        <AccessoryNoteCard
          cardKey="rearLightMounts"
          titleKey={closedKey("CARDS.REAR_LIGHT_MOUNTS")}
        />
        <AccessoryNoteCard
          cardKey="lashingStrips"
          titleKey={closedKey("CARDS.LASHING_STRIPS")}
        />
      </CardRow>
    </StructureSection>

    <AccessoriesTable />

    <StructureSection titleKey={closedKey("SECTIONS.VEHICLE_ADDONS")}>
      <CardRow columns={1}>
        <AccessoryNoteCard
          cardKey="wings"
          titleKey={closedKey("CARDS.WINGS")}
        />
      </CardRow>
    </StructureSection>
  </>
);

export default AccessoriesSafety;
